// Vendor imports
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('SearchDomainHeader')

function SearchDomainHeader(props) {
  return tag('div', {
    className: bem.block()
  },
    'Posts from ',
    tag('a', {
      className: bem.element('domain'),
      href: `http://${props.domain}`,
      rel: 'external nofollow noopener',
      target: '_blank'
    },
      props.domain
    )
  )
}

SearchDomainHeader.propTypes = {
  domain: PropTypes.string.isRequired
}

module.exports = SearchDomainHeader
